import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "menuTree--box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "menuTree--box--title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menuTree--box--titleContent" }, "一级"),
  /*#__PURE__*/_createElementVNode("div", { class: "menuTree--box--titleContent" }, "二级")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "menuTree--boxContentText"
}
const _hoisted_4 = { class: "menuTree--boxContentText__item" }
const _hoisted_5 = { class: "menuTree--boxContentText--subset" }
const _hoisted_6 = {
  key: 0,
  class: "menuTree--boxContentText--subset__item"
}
const _hoisted_7 = { class: "roleDetail__data" }
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_form_outlined = _resolveComponent("form-outlined")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "editorForm",
    class: "roleDetail__form",
    model: _ctx.recordData,
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol,
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        label: "角色名称",
        name: "roleName"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.recordData.roleName), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "角色说明",
        name: "instruction"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.recordData.instruction || '无'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "菜单权限",
        name: "menus"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuTree, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "menuTree--boxContent"
              }, [
                (item.state === 'OPEN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(item.menuName), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (_item, _index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: _index }, [
                      (_item.state === 'OPEN')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_item.menuName), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      (_ctx.recordData.roleName !== '部门主管')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "iconOfEditInPageDetail",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.revampData && _ctx.revampData(...args)))
          }, [
            _createVNode(_component_form_outlined)
          ]))
        : _createCommentVNode("", true),
      false
        ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 1,
            label: "数据权限"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.departmentMap[_ctx.recordData.departmentState]), 1)
              ]),
              (_ctx.recordData.departmentState === 'OTHER')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordData.departmentRes, (item) => {
                      return (_openBlock(), _createBlock(_component_a_tag, {
                        key: item.relId
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.departmentName), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model", "label-col", "wrapper-col"]))
}